import { FunctionComponent, useEffect } from "react";
import BasicCard from "@components/cards/BasicCard";
import { ReactComponent as LightOnSmall } from "src/static/images/light-on-small.svg";
import { TipsResponseDTO } from "@state/em_tips/dto/tips.response.dto";
import HTMLReactParser from "html-react-parser";

interface TipCardProps {
  tip: TipsResponseDTO;
  className?: string;
  onShare?: () => void;
  onSave?: () => void;
}

const TipCard: FunctionComponent<TipCardProps> = ({
  tip,
  className = "",
  onShare,
  onSave,
}) => {
  useEffect(() => {
    if (onShare) {
      document
        .querySelectorAll('span[data-type="share"]')
        .forEach((element) => {
          element.addEventListener("click", () => {
            onShare();
          });
        });
    }

    if (onSave) {
      document.querySelectorAll('span[data-type="save"]').forEach((element) => {
        element.addEventListener("click", () => onSave);
      });
    }
  });

  return (
    <BasicCard className={`card-tip ${className}`}>
      <div className="d-flex align-items-start">
        <div className="tip-icon">
          <LightOnSmall aria-hidden="true" focusable="false" />
        </div>
        <div className="tip-content">{HTMLReactParser(tip.content)}</div>
      </div>
    </BasicCard>
  );
};

export default TipCard;
